<template>
  <div>
    <dx-grid
      :url="url"
      :columns="columns"
      :title="title"
      :beforeSetupGrid="beforeSetupGrid"
      :actions="actions"
      ref="grid"
      :selectionEnabled="false"
      :onRowClicked="onRowClicked"
      navigationPath="onRowClicked"
      navigationField="onRowClicked"
    ></dx-grid>
    <v-dialog persistent v-model="newMapUser.dialog" max-width="600">
      <v-card class="pa-4">
        <v-form ref="newMapUserForm">
          <v-layout row>
            <v-card-title class="headline pl-0 pt-0 pb-2"
              >Map new user {{
            }}</v-card-title>
          </v-layout>

          <manage-engine-user-autocomplete
            :active="newMapUser.manageEngineUserAutocomplete"
            @selectedUser="newMapUser.selectedManageengineUser = $event"
          />

          <portal-user-autocomplete
            :active="newMapUser.portalUserAutocomplete"
            @selectedUser="newMapUser.selectedPortalUser = $event"
            @portalUsers="newMapUser.portalUsers = $event"
          />

          <v-card-actions class="mr-0 mt-3 ml-0 pb-0">
            <v-spacer></v-spacer>

            <v-btn color="default" dark @click="resetNewMapUser()"
              >Cancel</v-btn
            >
            <v-btn
              :loading="processing"
              color="success"
              @click="saveNewMapUser()"
            >
              save
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="mapExtension.dialog" max-width="600">
      <v-card class="pa-4">
        <v-form ref="mapExtensionForm">
          <v-layout row>
            <v-card-title class="headline pl-0 pt-0 pb-2"
              >Map Extension {{
            }}</v-card-title>
          </v-layout>
          <manage-engine-user-autocomplete
            :active="mapExtension.manageEngineUserAutocomplete"
            @selectedUser="mapExtension.selectedManageengineUser = $event"
            @manageEngineUsers="mapExtension.manageEngineUsers = $event"
          />
          <div style="display: flex; align-items: center; gap: 8px;"></div>
          <v-text-field
            v-model="mapExtension.selectedExtension"
            label="Extension"
            placeholder="Enter a 5-digit number"
            outlined
            style="flex: 1;"
            :rules="[rules.extension]"
          />
          <v-card-actions class="mr-0 mt-3 ml-0 pb-0">
            <v-spacer></v-spacer>

            <v-btn color="default" dark @click="resetMapExtension()"
              >Cancel</v-btn
            >
            <v-btn
              :loading="processing"
              color="success"
              @click="saveMapExtension()"
            >
              save
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="mapPhone.dialog" max-width="600">
      <v-card class="pa-4">
        <v-form ref="mapPhoneForm">
          <v-layout row>
            <v-card-title class="headline pl-0 pt-0 pb-2"
              >Map Phone {{
            }}</v-card-title>
          </v-layout>
          <manage-engine-user-autocomplete
            :active="mapPhone.manageEngineUserAutocomplete"
            @selectedUser="mapPhone.selectedManageengineUser = $event"
            @manageEngineUsers="mapPhone.manageEngineUsers = $event"
          />
          <div style="display: flex; align-items: center; gap: 8px;"></div>
          <v-text-field
            v-model="mapPhone.selectedPhone"
            label="Phone"
            placeholder="Enter a 10-digit number"
            outlined
            style="flex: 1;"
            :rules="[rules.phone]"
          />
          <v-card-actions class="mr-0 mt-3 ml-0 pb-0">
            <v-spacer></v-spacer>

            <v-btn color="default" dark @click="resetMapPhone()">Cancel</v-btn>
            <v-btn
              :loading="processing"
              color="success"
              @click="saveMapPhone()"
            >
              save
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="userView.dialog"
      max-width="30%"
      style="background-color: brown;"
    >
      <manageengine-user-view
        :style="{ padding: '0 !important' }"
        :key="userView.dialogKey"
        :initial-data="{ user: userView.user }"
        @closeUserDialog="userView.dialog = false"
      />
    </v-dialog>
  </div>
</template>

<script>
import { truncate } from "../../utils/helpers.js";
import ManageEngineUserAutocomplete from "./ManageEngineUserAutocomplete.vue";
import PortalUserAutocomplete from "./PortalUserAutocomplete.vue";
import ManageengineUserView from "./ManageengineUserView.vue";
export default {
  components: {
    ManageEngineUserAutocomplete,
    PortalUserAutocomplete,
    ManageengineUserView,
  },
  data: () => ({
    url: "",
    title: "ManageEngine Users",
    actions: [],

    processing: false,

    userView: {
      user: null,
      dialog: false,
      dialogKey: 0,
    },

    newMapUser: {
      manageEngineUserAutocomplete: false,
      portalUserAutocomplete: false,
      dialog: false,
      selectedPortalUser: "",
      selectedManageengineUser: "",
      portalUsers: [],
    },

    mapExtension: {
      manageEngineUserAutocomplete: false,
      dialog: false,
      selectedExtension: "",
      selectedManageengineUser: "",
      manageEngineUsers: [],
    },

    mapPhone: {
      manageEngineUserAutocomplete: false,
      dialog: false,
      selectedPhone: "",
      selectedManageengineUser: "",
      manageEngineUsers: [],
    },

    rules: {
      required: (value) => !!value || "Required.",
      extension: (v) => /^\d{5}$/.test(v) || "Enter a valid extension",
      phone: (v) =>
        /^\d{10}$/.test(v) ||
        "Enter a valid phone without dashes or parentheses",
    },
    columns: [
      {
        label: "Name",
        field: "name",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Email Id",
        field: "emailId",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Mapped Portal Username",
        field: "portalUsername",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Site",
        field: "siteName",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Department",
        field: "departmentName",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Phone in ManageEngine",
        field: "phone",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Mapped Phone",
        field: "phoneMapped",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Extension",
        field: "extension",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Id",
        field: "id",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
    ],
  }),

  created() {
    this.actions.push({
      text: "Map Extension",
      action: this.openMapExtensionDialog,
    });
    this.actions.push({
      text: "Map Phone",
      action: this.openMapPhoneDialog,
    });
    this.actions.push({
      text: "Map User",
      action: this.openMapUserDialog,
    });
    this.actions.push({
      text: "Sync Users",
      action: this.syncUsers,
    });
  },

  methods: {
    async beforeSetupGrid() {
      this.url = `ManageEngineUsers`;
    },
    async syncUsers() {
      try {
        const response = await this.$http.post(
          "api/ManageengineUsers/SyncManageengineUsers"
        );
        return response;
      } catch (error) {}
    },
    truncateText(text, count = 25) {
      return truncate(text, count);
    },

    async openMapUserDialog() {
      this.newMapUser.dialog = true;
      this.newMapUser.manageEngineUserAutocomplete = true;
      this.newMapUser.portalUserAutocomplete = true;
    },

    resetNewMapUser() {
      this.newMapUser = {
        dialog: false,
        selectedPortalUser: "",
        selectedManageengineUser: "",
        manageEngineUserAutocomplete: false,
        portalUserAutocomplete: false,
      };

      this.processing = false;
      this.$refs.newMapUserForm.resetValidation(true);
    },

    async saveNewMapUser() {
      if (!this.$refs.newMapUserForm.validate(true)) {
        return;
      }
      const user = this.newMapUser.selectedManageengineUser;

      if (user && user.portalUsername != null) {
        return this.$notify({
          group: "notification",
          text: user.name + " is already mapped to " + user.portalUsername,
          type: "error",
        });
      }

      const existUser = this.newMapUser.portalUsers.find(
        (u) =>
          u.userName &&
          u.userName.toLowerCase() == user.emailId &&
          user.emailId.toLocaleLowerCase()
      );
      if (existUser) {
        return this.$notify({
          group: "notification",
          text: `${user.name} ${user.emailId} is a portal username.`,
          type: "error",
        });
      }

      this.processing = true;
      try {
        await this.$http.post(
          `api/ManageengineUsers/MapUser?portalUsername=${
            this.newMapUser.selectedPortalUser
          }&manageengineUserID=${user.id}`
        );
        this.$refs.grid.reloadGrid();
        this.processing = false;
        this.$notify({
          group: "notification",
          text: "Mappet user Saved",
          type: "success",
        });
      } catch (e) {
        console.error(e);
      } finally {
        this.resetNewMapUser();
      }
    },

    async openMapExtensionDialog() {
      this.mapExtension.dialog = true;
      this.mapExtension.manageEngineUserAutocomplete = true;
    },

    resetMapExtension() {
      this.mapExtension = {
        manageEngineUserAutocomplete: false,
        dialog: false,
        selectedExtension: "",
        selectedManageengineUser: "",
      };

      this.processing = false;
      this.$refs.mapExtensionForm.resetValidation(true);
    },
    async saveMapExtension() {
      if (!this.$refs.mapExtensionForm.validate(true)) {
        return;
      }
      const user = this.mapExtension.selectedManageengineUser;

      if (user && user.extension != null) {
        return this.$notify({
          group: "notification",
          text:
            user.name + " is already mapped with extension " + user.extension,
          type: "error",
        });
      }

      const existExt = this.mapExtension.manageEngineUsers.find(
        (u) => u.extension == this.mapExtension.selectedExtension
      );
      if (existExt) {
        return this.$notify({
          group: "notification",
          text: `${this.mapExtension.selectedExtension} is already mapped to ${
            existExt.name
          } ${existExt.emailId}`,
          type: "error",
        });
      }

      this.processing = true;
      try {
        await this.$http.post(
          `api/ManageengineUsers/MapExtension?extension=${
            this.mapExtension.selectedExtension
          }&manageengineUserID=${user.id}`
        );
        this.$refs.grid.reloadGrid();
        this.processing = false;
        this.$notify({
          group: "notification",
          text: "Mappet Extension Saved",
          type: "success",
        });
      } catch (e) {
        console.error(e);
      } finally {
        this.resetMapExtension();
      }
    },

    async openMapPhoneDialog() {
      this.mapPhone.dialog = true;
      this.mapPhone.manageEngineUserAutocomplete = true;
    },

    resetMapPhone() {
      this.mapPhone = {
        manageEngineUserAutocomplete: false,
        dialog: false,
        selectedPhone: "",
        selectedManageengineUser: "",
      };

      this.processing = false;
      this.$refs.mapPhoneForm.resetValidation(true);
    },

    async saveMapPhone() {
      if (!this.$refs.mapPhoneForm.validate(true)) {
        return;
      }
      const user = this.mapPhone.selectedManageengineUser;

      if (user && user.phoneMapped != null) {
        return this.$notify({
          group: "notification",
          text: user.name + " is already mapped with phone " + user.phoneMapped,
          type: "error",
        });
      }
      const existPhone = this.mapPhone.manageEngineUsers.find(
        (u) => u.phoneMapped == this.mapPhone.selectedPhone
      );
      if (existPhone) {
        return this.$notify({
          group: "notification",
          text: `${this.mapPhone.selectedPhone} is already mapped to ${
            existPhone.name
          } ${existPhone.emailId}`,
          type: "error",
        });
      }

      this.processing = true;
      try {
        await this.$http.post(
          `api/ManageengineUsers/MapPhone?phone=${
            this.mapPhone.selectedPhone
          }&manageengineUserID=${user.id}`
        );
        this.$refs.grid.reloadGrid();
        this.processing = false;
        this.$notify({
          group: "notification",
          text: "Mappet Phone Saved",
          type: "success",
        });
      } catch (e) {
        console.error(e);
      } finally {
        this.resetMapPhone();
      }
    },
    async onRowClicked(row) {
      this.userView.user = { ...row };
      this.userView.dialog = true;
      this.userView.dialogKey += 1;
    },
  },
};
</script>
